<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">گزارش محصولات</h5>
        <div style="flex: 1"></div>
        <ExcelDownload class="mr-3" :url="excelUrl" />
      </div>
      <div class="row px-4 not-in-print">
        <div class="row col-12 mb-1">
            <b-form-group class="col-4">
              <multiselect
                  placeholder="انتخاب انبار"
                  v-model="selectedStore"
                  open-direction="bottom"
                  :options="stores"
                  label="label"
                  track-by="id"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  :disabled="disabled"
              >
                  <template slot="noOptions"> موردی یافت نشد </template>
                  <template slot="noResult"> موردی یافت نشد </template>
              </multiselect>
            </b-form-group>
            <DatePickerRange class="col-md-6" v-model="filterDate" />
        </div>
        <div class="row col-md-12">
          <div class="col-4">
            <b-form-group label="دسته بندی">
                <treeselect
                    :options="realOptions"
                    v-model="category_id"
                    :searchable="true"
                    :show-count="true"
                    noChildrenText="فرزندی وجود ندارد"
                    noOptionsText="موردی وجود ندارد"
                    noResultsText="موردی یافت نشد"
                    :default-expand-level="1"
                    label="title"
                >
                    <label
                    slot="option-label"
                    slot-scope="{
                        node,
                        shouldShowCount,
                        count,
                        labelClassName,
                        countClassName,
                    }"
                    :class="labelClassName"
                    >
                    {{ node.label }}
                    </label>
                </treeselect>
            </b-form-group>
          </div>
              <b-form-group class="col-md-3">
                <div class="d-flex">
                  <label
                    @click="
                      () =>
                        (includeUnsold = includeUnsold
                          ? 0
                          : 1)
                    "
                    class="ml-2"
                    >محصولات فروخته نشده</label
                  >
                  <b-form-checkbox
                    :unchecked-value="0"
                    :disabled="disabled"
                    :value="1"
                    v-model="includeUnsold"
                  />
                </div>
              </b-form-group>
        </div>
        <ProductSearch
          class="row col-md-12"
          ref="productSearch"
          :selectable="true"
          :disabled="disabled"
          @selectProduct="selectProduct"
          :show-label="false"
          :store="selectedStore"
          @selectVariety="selectVariety"
        />
        <b-button
          class="col-md-2"
          variant="primary"
          @click="doFilter"
          :disabled="disabled"
          >فیلترسازی</b-button
        >
      </div>
      <div id="print" class="p-4">
        <b-table
          id="main-table"
          v-if="reports && reports.length > 0"
          bordered
          striped
          :fields="fields"
          :items="displayedReports"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          responsive="sm"
        >
            <template v-slot:cell(variety_id)="data">  
                  <a  
                  :href="`/admin/products/edit/${data.item.variety_id}`"  
                  class="btn btn-primary"  
                  target="_blank"  
                  rel="noopener noreferrer"  
                >{{ data.item.variety_id }}</a>  
            </template>  
          <template v-slot:cell(total_sale)="data">
            {{ data.item.total_sale < 0 ? "-" : ""
            }}{{ data.item.total_sale | price }}
          </template>
          <template v-slot:cell(variety_title)="data">
            <a
              target="_blank"
              v-if="data.item.product_title"
              :href="'/admin/products/edit/' + data.item.product_id"
              >{{ data.item.product_title }}</a
            >
            <span v-else>{{ data.item.variety_title }}</span>
          </template>

          <template v-slot:cell(0)="data">
            {{ data.item.stores[1].quantity | price }}
          </template>
            <template v-slot:cell(1)="data">
            {{ data.item.stores[2].quantity | price }}
          </template>
          <template v-slot:cell(2)="data">
            {{ data.item.stores['3'].quantity | price }}
          </template>
          <template v-slot:cell(refund_count)="data">
            {{ data.item.refund_count | price }}
          </template>
          <template v-slot:cell(sales_count)="data">
            {{ data.item.sales_count | price }}
          </template>
          <template v-slot:cell(sell_price)="data">
            {{ data.item.sell_price | price }}
          </template>
          <template v-slot:cell(sum_refund_amount)="data">
            {{ data.item.sum_refund_amount | price }}
          </template>
          <template v-slot:cell(sum_sales_amount)="data">
            {{ data.item.sum_sales_amount | price }}
          </template>
          <template v-slot:cell(total)="data">
            {{ data.item.total | price }}
          </template>
          <template v-slot:cell(sum_discount_amount)="data">
            {{ data.item.sum_discount_amount | price }}
          </template>
          <template #bottom-row="data">
            <b-td colspan="3">
              <div class="text-center">جمع کل</div>
            </b-td>
            <b-td>
              {{ totals.discount_amount | price }}
            </b-td>
            <b-td>
              {{ totals.quantity | price }}
            </b-td>
            <b-td>
              {{ totals.amount | price }}
            </b-td>
            <b-td>
              *
            </b-td>
            <b-td>
              *
            </b-td>
            <b-td>
              *
            </b-td>
          </template>
        </b-table>
        <div class="text-center my-3" v-if="reports.length > displayedReports.length">
          <button class="btn btn-primary" :disabled="disabled" @click="loadMore">مشاهده بیشتر</button>
        </div>
        <div v-if="categories && !reports" class="alert alert-primary">دیتایی وجود ندارد</div>
        <div v-else-if="categories && disabled" class="alert alert-primary">در حال بارگزاری</div>
      </div>
    </div>
  </main>
</template>

<script>
import { BTable, BFormCheckbox, BFormGroup, BFormInput, BButton, BTd } from "bootstrap-vue";
import configProvider from "@@/core/configProvider";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import reportMixin from "@@/core/mixins/reportMixin";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";

function Filter() {
  this.search = "";
}
Filter.prototype.set = function(filters) {
  Object.entries(filters).forEach(([index, value]) => {
    this[index] = value;
  });
};
export default {
  name: "storeBalanceReport",
  components: {
    BTable,
    BFormGroup,
    BFormInput,
    Treeselect,
    ExcelDownload,
    BFormCheckbox,
    DatePickerRange,
    ProductSearch,
    BButton,
    BTd,
  },
  configProvider,
  data() {
    return {
      disabled: true,
      fields: [
        {
          key: "product_id",
          label: "شناسه محصول",
          sortable: true,
        },
        {
          key: "variety_title",
          label: "عنوان",
          sortable: true,
        },
        {
          key: "sell_price",
          label: "قیمت فروش",
          sortable: true,
        },
        {
          key: "sum_discount_amount",
          label: "تخفیف",
          sortable: true,
        },
        {
          key: "sales_count",
          label: "تعداد فروش",
          sortable: true,
        },
        {
          key: "sum_sales_amount",
          label: "جمع فروش",
          sortable: true,
        },
        {
          key: "0",
          label: "انبار مرکزی",
          sortable: true,
        },
        {
          key: "1",
          label: "انبار فروشگاه گرگان",
          sortable: true,
        },
        {
          key: "2",
          label: "انبار فروشگاه ساری",
          sortable: true,
        },
      ],
      page: 1,
      reports: [], 
      displayedReports: [], 
      perPage: 80,  
      currentIndex: 0,
      sortBy: null,
      sortDesc: null,
      category_id: null,
      categories: [],
      selectedStore: null,
      includeUnsold: false,
      stores: [],
      totals : [],
      Product_id: "",
      Variety_id: "",
      sortBy: null,
      sortDesc: null,
      filter: new Filter(),
      filterDate: {
        endDate: "",
        startDate: "",
      },
      appliedFilter: new Filter(),
      disabledRest: true,
    };
  },
  mixins: [reportMixin],

  created() {
    this.loadStores();
    this.loadCategoriesData();
  },
  computed: {
      excelUrl() {
        const params = {
          category_id: this.category_id == 0 || !this.category_id ? '' : this.category_id,
          product_id: this.Product_id ? this.Product_id.id : "",
          variety_id: this.Variety_id ? this.Variety_id.id : "",
          from_date: this.filterDate.startDate,
          include_unsold: this.includeUnsold,
          store_id: this.selectedStore ? this.selectedStore.id : '',
          to_date: this.filterDate.endDate,
        };

        const queryString = Object.entries(params)
          .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
          .join('&');

        return `admin/reports/products-new?${queryString}`;
      },
    realOptions() {
      let temp = this.$root.addLabel(this.categories);
      temp.unshift({
          label: "ندارد",
          children: [],
          id: 0,
      });

      return temp;
    },
    sum_refund_count() {
      if (this.reports) {
        return this.reports.reduce(
          (total, item) => total + Number(item.refund_count),
          0
        );
      } else {
        return 0;
      }
    },
    sum_sales_count() {
      if (this.reports) {
        return this.reports.reduce(
          (total, item) => total + Number(item.sales_count),
          0
        );
      } else {
        return 0;
      }
    },
    sum_discount_amount() {
      if (this.reports) {
        return this.reports.reduce(
          (total, item) => total + Number(item.sum_discount_amount),
          0
        );
      } else {
        return 0;
      }
    },
    sum_sales_amount() {
      if (this.reports) {
        return this.reports.reduce(
          (total, item) => total + Number(item.sum_sales_amount),
          0
        );
      } else {
        return 0;
      }
    },
    sum_refund_amount() {
      if (this.reports) {
        return this.reports.reduce(
          (total, item) => total + Number(item.sum_refund_amount),
          0
        );
      } else {
        return 0;
      }
    },
    total() {
      if (this.reports) {
        return this.reports.reduce(
          (total, item) => total + Number(item.total),
          0
        );
      } else {
        return 0;
      }
    },
  
  },
  watch: {
    reports() {
      this.displayedReports = []; 
      this.currentIndex = 0;
      this.loadMore();
    }
  },
  methods: {
    async loadCategoriesData() {
      try {
      const response = await this.$axios.get("admin/categories",{params: {all: 1},});
      this.categories = response.data.data.categories;
      } catch (e) {
          this.$root.notify(e);
      } finally {
          this.disabled = false;
      }
    },
    async loadStores(){
      try {
          const response = await this.$axios.get("admin/stores");
          this.stores = response.data.data.stores;
          this.disabled = false;
      } catch (e) {
          this.$root.notify(e);
      } 
    },
    resetFilter() {
      this.Product_id = "";
      this.Variety_id = "";
      this.disabledRest = true;
      this.loadData();
    },
    doFilter() {
      this.loadData();
    },
    changePage(page = 1) {
      this.previousPage = this.page;
      this.page = page;
      this.loadData();
    },
    selectVariety(data) {
      this.Variety_id = data;
    },
    selectProduct(data) {
      this.Product_id = data;
    },
    async loadData() {
    try {
      const response = await this.$axios.get("admin/reports/products-new", {
        params: {
          category_id: this.category_id == 0 || !this.category_id ? '' : this.category_id,
          product_id: this.Product_id ? this.Product_id.id : "",
          variety_id: this.Variety_id ? this.Variety_id.id : "",
          from_date: this.filterDate.startDate,
          store_id: this.selectedStore ? this.selectedStore.id : '',
          to_date: this.filterDate.endDate,
          include_unsold: this.includeUnsold,
        },
      });
      this.reports = response.data.data.reports; 
      this.totals = response.data.data.totals; 
      this.currentIndex = 0; 
      this.loadMore(); 
    } catch (e) {
      this.$root.notify(e);
    }
  },
  async loadMore() {
    this.disabled = true;
    await this.$nextTick(); 
    const start = this.currentIndex;
    const end = start + this.perPage;
    const nextItems = this.reports.slice(start, end).map(report => {
      return {
        ...report,
        '0': report.stores[1]?.quantity || 0,
        '1': report.stores[2]?.quantity || 0,
        '2': report.stores[3]?.quantity || 0,
      };
    });
    this.displayedReports = [...this.displayedReports, ...nextItems];
    this.currentIndex += this.perPage;
    this.disabled = false;
  },
  showVarieties(productId) {
    this.$root.$emit("bv::show::modal", "show-varieties-modal");
    this.showVarietiesProductId = productId;
  },
  },
};
</script>

<style>
.print-only {
  display: none;
}
@media print {
  .not-in-print {
    display: none !important;
  }

  .app-content .side-app {
    padding: 0 !important;
  }

  .print-only {
    display: block !important;
  }

  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
    font-size: 1.25rem;
  }
  #print {
    padding: 0 !important;
  }
  #print {
    width: 80%;
  }

  #main-table th:last-child,
  #main-table td:last-child {
    display: none;
  }

  #print .not-in-print {
    display: none;
  }

  .mr-2-print {
    margin-right: 20px;
  }
}
</style>
